import { TrendingUp } from 'lucide-react';

import { defineArea } from '../../app/area';
import { ReplenishmentPage } from './ReplenishmentPage';

/**
 * OWNER: the `replenishment` module agent (M3's second half — docs/MODULES.md
 * "Replenishment (spec §5.5)"; it has its own api module and contract file, so
 * it gets its own web area).
 * Owns: apps/web/src/areas/replenishment/**  ·  apps/api/src/modules/replenishment/**
 *       packages/shared/src/contracts/replenishment.ts
 *       packages/shared/src/i18n/{sv,en,zh}/replenishment.json
 */
export default defineArea({
  id: 'replenishment',
  nav: [
    {
      section: 'warehouse',
      to: '/warehouse/replenishment',
      labelKey: 'common:nav.replenishment.suggestions',
      icon: TrendingUp,
      permissions: ['warehouse.replenishment.view'],
      order: 85,
    },
  ],
  routes: [{ path: 'warehouse/replenishment', element: <ReplenishmentPage /> }],
});
